export default __webpack_public_path__ + "static/media/Eraser.c7eaf69d.svg";